import { z } from 'zod';

export enum VCycleElementContainerFilterLogicalConnector {
    AND = 'AND',
    OR = 'OR',
}

export const VCycleElementContainerFilterLogicalConnectorSchema = z.enum(VCycleElementContainerFilterLogicalConnector);